import React, { ComponentType, FunctionComponent, useContext } from "react";

import { Subtract } from "utility-types";
import { ProjectItemContext } from "./ProjectItemContext";
import { IWithProjectItemContextProps } from "./IWithProjectItemContextProps";

export function WithProjectItemContext<P extends IWithProjectItemContextProps>(
  Component: ComponentType<P>
): FunctionComponent<Subtract<P, IWithProjectItemContextProps>> {
  function ComponentWithContext(props: Subtract<P, IWithProjectItemContextProps>) {
    const context = useContext(ProjectItemContext);
    return <Component {...(props as P)} {...context} />;
  }

  const componentName = Component.displayName ?? Component.name ?? `Component`;
  ComponentWithContext.displayName = `WithProjectItemContext(${componentName})`;
  return ComponentWithContext;
}
